import type {GrowthBook} from '@growthbook/growthbook';
import {routes} from '../../config/routes';
import {generateLoginUrl} from '../../shared/utils/login-url';
import {getLanguagePath, getRoutePath} from '../utils/language';

type LegacyRoute = {
  flag: string;
  getLegacyPath: (location: Location) => string;
};

const legacyRoutes: Record<string, LegacyRoute> = {
  [routes.REGISTER_PATH]: {
    flag: 'ff-web-account__account-register',
    getLegacyPath: ({search}) => `/profile/register${search}`,
  },
  [routes.LOGIN_PATH]: {
    flag: 'ff-web-account__account-login',
    getLegacyPath: ({hostname, search, hash}) => {
      const searchParams = new URLSearchParams(search);

      if (searchParams.has('finalizeOrder')) {
        searchParams.delete('finalizeOrder');
        return `/m/#checkout-log-in?${searchParams.toString()}`;
      }

      const route = searchParams.get('route');
      const loginUrl = generateLoginUrl(
        hostname,
        route ? encodeURIComponent(route) : undefined
      );
      return `${loginUrl}${hash}`;
    },
  },
};

export const getLegacyRedirectUrl = (gb: GrowthBook, location: Location) => {
  const legacyRoute = legacyRoutes[getRoutePath(location.pathname)];

  if (!legacyRoute || gb.getFeatureValue<boolean>(legacyRoute.flag, false)) {
    return null;
  }

  return `${getLanguagePath(location.pathname)}${legacyRoute.getLegacyPath(location)}`;
};
